export const name = "CEILING";
export const summary = `Synonym of \`CEIL\`.`;
export const reference = `
## CEILING

Synonym of \`CEIL\`.

\`\`\`
CEILING(X)
\`\`\`

### Description

Synonym of CEIL(X)


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
